import React, { useEffect, useState } from "react";
import _ from "lodash";
import { Row, Col, Form, Button, InputGroup, Card, Spinner } from "react-bootstrap";
import ContentWrapper from "../../../../Wrapper";
import BillingSubHeader from "../../components/billing-sub-header";
import { InputLimit } from "../../../../../constants";
import AddStripeBalanceModel from "./add-stripe-balance.model";
import { useDispatch, useSelector } from "react-redux";
import * as walletActions from "../../store/actions/wallet_billing_actions";
import { dispatchSnackbarError } from "../../../../../utils/toaster";
import { GreenGradientButton } from "../../../../../components/button";
import validator from "validator";
import { getVendorKey } from "./constants";
import { useHistory } from "react-router-dom";
import * as subscriptionV2Actions from "../../store/actions/subscription_billing_v2_actions";

const options = {
  "₹": [1000, 10000, 25000, 50000],
  $: [10, 100, 250, 500],
};
const RazorpaySVG = <svg width="208" height="44" viewBox="0 0 208 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1101_14221)">
    <path d="M13.3452 11.6032L11.62 17.9531L21.4949 11.567L15.0365 35.6634L21.5957 35.6688L31.1366 0.0774918" fill="#3395FF" />
    <path d="M2.71657 25.5387L0 35.6688H13.4437L18.9448 15.0613L2.71657 25.5387ZM49.4153 16.6201C49.0867 17.8414 48.4535 18.7385 47.5093 19.3114C46.5673 19.8832 45.2451 20.1702 43.5385 20.1702H38.1163L40.0201 13.0721H45.4423C47.1467 13.0721 48.3177 13.3569 48.953 13.9375C49.5884 14.518 49.7417 15.4053 49.4153 16.6321M55.0292 16.4788C55.7193 13.9156 55.4345 11.9439 54.1726 10.5637C52.9129 9.19444 50.7024 8.50434 47.5477 8.50434H35.4469L28.1625 35.6809H34.0415L36.9771 24.727H40.8329C41.6983 24.727 42.3796 24.8694 42.8769 25.1433C43.3753 25.4281 43.6678 25.921 43.7576 26.633L44.807 35.6809H51.1055L50.0846 27.2464C49.8765 25.3623 49.0144 24.256 47.4995 23.9274C49.4306 23.3687 51.0485 22.4377 52.352 21.1451C53.6465 19.862 54.5713 18.2538 55.0292 16.4897M69.3196 25.9539C68.8267 27.7941 68.0709 29.1852 67.0489 30.1601C66.0258 31.135 64.8034 31.617 63.3772 31.617C61.9247 31.617 60.9399 31.146 60.4196 30.193C59.8982 29.24 59.8807 27.8598 60.3648 26.0524C60.849 24.245 61.6212 22.832 62.6838 21.8133C63.7463 20.7946 64.9885 20.2852 66.4147 20.2852C67.8387 20.2852 68.8136 20.7782 69.3065 21.7563C69.8104 22.7389 69.8213 24.1443 69.3284 25.9736L69.3196 25.9539ZM71.896 16.3364L71.1599 19.0858C70.8422 18.0999 70.2255 17.3113 69.3142 16.7197C68.4006 16.1392 67.2702 15.8434 65.9217 15.8434C64.2677 15.8434 62.6794 16.2706 61.1568 17.125C59.6342 17.9794 58.2978 19.1844 57.1586 20.7398C56.0194 22.2953 55.1869 24.0588 54.6502 26.0415C54.1244 28.0351 54.0148 29.7768 54.3325 31.2884C54.6611 32.811 55.3512 33.9721 56.4137 34.7827C57.4872 35.6042 58.8565 36.0095 60.5324 36.0095C61.8642 36.0162 63.1809 35.7282 64.3882 35.1661C65.5818 34.6277 66.6435 33.8351 67.4991 32.8438L66.7323 35.7094H72.4174L77.6085 16.3462H71.9124L71.896 16.3364ZM98.0375 16.3364H81.5048L80.3491 20.6522H89.9689L77.2514 31.6389L76.1647 35.6918H93.2309L94.3866 31.376H84.0789L96.9914 20.225M112.59 25.921C112.078 27.827 111.319 29.2597 110.317 30.193C109.315 31.135 108.101 31.606 106.676 31.606C103.696 31.606 102.717 29.711 103.734 25.921C104.237 24.0369 105 22.6206 106.019 21.6665C107.037 20.7091 108.272 20.2316 109.723 20.2316C111.147 20.2316 112.109 20.7059 112.604 21.661C113.099 22.614 113.095 24.0347 112.59 25.9188M115.918 17.0648C114.609 16.2498 112.938 15.8423 110.901 15.8423C108.838 15.8423 106.929 16.2476 105.172 17.0582C103.422 17.8637 101.884 19.0662 100.681 20.57C99.4429 22.0926 98.5524 23.8781 98.0058 25.9155C97.469 27.9453 97.4033 29.7275 97.8195 31.2533C98.2358 32.7759 99.1121 33.948 100.427 34.7586C101.752 35.5757 103.439 35.9821 105.509 35.9821C107.547 35.9821 109.442 35.5724 111.183 34.7575C112.925 33.9381 114.415 32.7748 115.653 31.2413C116.89 29.7143 117.778 27.9332 118.325 25.8958C118.873 23.8584 118.939 22.0795 118.522 20.5503C118.106 19.0277 117.241 17.8557 115.937 17.0396M136.213 21.5088L137.67 16.24C137.177 15.988 136.531 15.8566 135.72 15.8566C134.417 15.8566 133.168 16.1786 131.963 16.8315C130.927 17.3857 130.046 18.1678 129.301 19.1471L130.057 16.3101L128.406 16.3166H124.353L119.128 35.6721H124.893L127.604 25.554C127.999 24.0829 128.708 22.9251 129.733 22.1036C130.751 21.2787 132.022 20.8658 133.556 20.8658C134.498 20.8658 135.374 21.0816 136.206 21.5121M152.254 26.0141C151.761 27.8215 151.016 29.2017 149.997 30.1547C148.979 31.112 147.752 31.5896 146.328 31.5896C144.904 31.5896 143.929 31.1076 143.414 30.1437C142.888 29.1743 142.877 27.7777 143.37 25.9418C143.863 24.107 144.619 22.6995 145.66 21.7246C146.7 20.742 147.927 20.2513 149.351 20.2513C150.753 20.2513 151.695 20.7551 152.199 21.7739C152.703 22.7926 152.714 24.2056 152.23 26.013M156.261 17.0966C155.193 16.2422 153.829 15.815 152.175 15.815C150.726 15.815 149.345 16.1436 148.034 16.8074C146.725 17.4701 145.663 18.3738 144.847 19.5174L144.867 19.3859L145.834 16.3079H140.204L138.769 21.6643L138.725 21.8505L132.81 43.916H138.582L141.562 32.8088C141.858 33.7968 142.46 34.5724 143.38 35.1332C144.3 35.6918 145.436 35.969 146.787 35.969C148.463 35.969 150.062 35.5637 151.579 34.7531C153.102 33.9403 154.416 32.7704 155.534 31.2588C156.651 29.7472 157.48 27.9946 158.009 26.0119C158.546 24.026 158.655 22.2547 158.349 20.7048C158.036 19.1526 157.345 17.951 156.278 17.1009M175.409 25.9352C174.916 27.7645 174.161 29.1666 173.142 30.1306C172.123 31.1011 170.896 31.5841 169.472 31.5841C168.015 31.5841 167.03 31.1131 166.515 30.1601C165.989 29.2071 165.978 27.827 166.46 26.0196C166.942 24.2122 167.711 22.7991 168.774 21.7804C169.836 20.7617 171.079 20.2535 172.506 20.2535C173.93 20.2535 174.893 20.7464 175.397 21.7213C175.901 22.6995 175.905 24.1048 175.414 25.9385L175.409 25.9352ZM177.984 16.3123L177.246 19.0617C176.929 18.0704 176.315 17.2817 175.406 16.6956C174.486 16.1107 173.358 15.8193 172.01 15.8193C170.356 15.8193 168.759 16.2465 167.234 17.1009C165.712 17.9553 164.376 19.1537 163.236 20.7048C162.097 22.2558 161.265 24.0238 160.728 26.0064C160.197 27.9967 160.093 29.7417 160.41 31.2599C160.731 32.7715 161.422 33.9392 162.491 34.7542C163.558 35.5648 164.934 35.9744 166.61 35.9744C167.957 35.9744 169.245 35.694 170.466 35.131C171.657 34.5901 172.716 33.7966 173.569 32.8055L172.802 35.6732H178.487L183.677 16.3177H177.992L177.984 16.3123ZM207.545 16.3188L207.548 16.3134H204.054C203.942 16.3134 203.844 16.3188 203.742 16.321H201.929L200.998 17.6136L200.768 17.9203L200.669 18.0736L193.303 28.3352L191.78 16.3188H185.747L188.803 34.5789L182.055 43.9226H188.069L189.701 41.608C189.747 41.5401 189.789 41.4831 189.843 41.4109L191.749 38.7052L191.804 38.6286L200.34 26.5245L207.537 16.3375L207.548 16.3309H207.545V16.3188Z" fill="#072654" />
  </g>
  <defs>
    <clipPath id="clip0_1101_14221">
      <rect width="207.548" height="44" fill="white" />
    </clipPath>
  </defs>
</svg>


const StripeSVG = <svg width="106" height="44" viewBox="0 0 106 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1102_14236)">
    <path d="M7.39821 17.165C7.39821 16.0246 8.33396 15.586 9.88378 15.586C12.1062 15.586 14.9134 16.2585 17.1358 17.4574V10.5856C14.7087 9.6206 12.3109 9.24046 9.88378 9.24046C3.94766 9.24046 0 12.3401 0 17.5159C0 25.5867 11.1119 24.3001 11.1119 27.7799C11.1119 29.125 9.94226 29.5636 8.30471 29.5636C5.87763 29.5636 2.77799 28.5694 0.321661 27.2243V34.1838C3.04116 35.3535 5.78991 35.8506 8.30471 35.8506C14.387 35.8506 18.5686 32.8387 18.5686 27.6044C18.5394 18.8903 7.39821 20.4401 7.39821 17.165ZM27.1658 3.39207L20.0307 4.91265L20.0015 28.3355C20.0015 32.6633 23.2473 35.8506 27.5752 35.8506C29.973 35.8506 31.7275 35.412 32.6925 34.8856V28.9495C31.7568 29.3297 27.1365 30.6748 27.1365 26.347V15.9661H32.6925V9.73757H27.1365L27.1658 3.39207ZM41.7867 11.9015L41.3189 9.73757H35.0026V35.3243H42.3131V17.9838C44.0384 15.7322 46.9626 16.1416 47.8691 16.4632V9.73757C46.9333 9.38667 43.512 8.74334 41.7867 11.9015ZM49.6528 9.73757H56.9926V35.3243H49.6528V9.73757ZM49.6528 7.51518L56.9926 5.93612V0L49.6528 1.54982V7.51518ZM72.2569 9.24046C69.3911 9.24046 67.5489 10.5856 66.5254 11.5213L66.1453 9.70833H59.7121V43.8044L67.0225 42.2546L67.0518 33.9791C68.1045 34.7394 69.6543 35.8214 72.2276 35.8214C77.4619 35.8214 82.2284 31.6105 82.2284 22.3409C82.1991 13.8607 77.3742 9.24046 72.2569 9.24046ZM70.5023 29.3882C68.7771 29.3882 67.7536 28.7741 67.0518 28.0138L67.0225 17.165C67.7828 16.317 68.8355 15.7322 70.5023 15.7322C73.1634 15.7322 75.0056 18.7148 75.0056 22.5455C75.0056 26.464 73.1926 29.3882 70.5023 29.3882ZM105.271 22.6333C105.271 15.1473 101.645 9.24046 94.7147 9.24046C87.7551 9.24046 83.5443 15.1473 83.5443 22.5748C83.5443 31.3766 88.5154 35.8214 95.6504 35.8214C99.1302 35.8214 101.762 35.0319 103.75 33.9207V28.0723C101.762 29.0665 99.4811 29.6806 96.5862 29.6806C93.7497 29.6806 91.2349 28.6864 90.9132 25.2358H105.213C105.213 24.8557 105.271 23.3351 105.271 22.6333ZM90.8255 19.8553C90.8255 16.5509 92.8432 15.1766 94.6854 15.1766C96.4692 15.1766 98.3699 16.5509 98.3699 19.8553H90.8255Z" fill="#32325D" />
  </g>
  <defs>
    <clipPath id="clip0_1102_14236">
      <rect width="105.271" height="44" fill="white" />
    </clipPath>
  </defs>
</svg>

const PaddleSVG = <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M42.5979 42.6083H35.1937V31.0063C35.1937 28.2396 35.1375 24.6792 31.3354 24.6792C27.475 24.6792 26.8854 27.6896 26.8854 30.8021V42.6083H19.4812V18.75H26.5938V22.0021H26.6896C27.6833 20.1271 30.1 18.1479 33.7104 18.1479C41.2125 18.1479 42.6 23.0854 42.6 29.5125V42.6083H42.5979ZM11.1187 15.4854C10.5539 15.4857 9.99456 15.3746 9.47272 15.1584C8.95088 14.9423 8.47678 14.6253 8.07758 14.2257C7.67837 13.8261 7.36189 13.3517 7.14624 12.8297C6.93059 12.3076 6.82001 11.7482 6.82083 11.1833C6.82125 10.3329 7.07384 9.50163 7.54667 8.79473C8.0195 8.08783 8.69134 7.53701 9.47722 7.21194C10.2631 6.88686 11.1277 6.80213 11.9618 6.96845C12.7958 7.13477 13.5618 7.54467 14.1629 8.14633C14.7639 8.74799 15.1731 9.51437 15.3386 10.3486C15.5041 11.1828 15.4186 12.0473 15.0927 12.8329C14.7669 13.6184 14.2154 14.2897 13.5081 14.7619C12.8007 15.234 11.9692 15.4858 11.1187 15.4854ZM14.8312 42.6083H7.40625V18.75H14.8312V42.6083ZM46.3021 0H3.68958C1.65 0 0 1.6125 0 3.60208V46.3979C0 48.3896 1.65 50 3.68958 50H46.2958C48.3333 50 50 48.3896 50 46.3979V3.60208C50 1.6125 48.3333 0 46.2958 0H46.3021Z" fill="#0076B3" />
</svg>



export default function WalletBilling(props) {
  const [lowCreditNotification, setLowCreditNotification] = useState("");
  const [threshold, setThreshold] = useState(100);
  const [showAutoRechargeModal, setShowAutoRechargeModal] = useState(false);
  const [vendor, setVendor] = useState("stripe");

  // const [showAddBalanceInput, setShowAddBalanceInput] = useState(true)
  const [addBalance, setAddBalance] = useState(0);
  const [clientSecret, setClientSecrent] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabledCurreny, setDisabledCurreny] = useState(false);
  const [paddlePayOptions, setPaddlePayOptions] = useState([]);

  // wallet info
  const [balance, setBalance] = useState("0");
  const [currency, setCurrency] = useState("$");
  const [isCredit, setIsCredit] = useState(false);
  const [planCurrency, setPlanCurrency] = useState("");

  const dispatch = useDispatch();
  const history = useHistory()
  const Paddle = window.Paddle;

  const walletInfoStore = useSelector((store) => store.Billing.wallet.info);
  const accountBillingStore = useSelector((state) => state.Billing.subscriptionv2.billing);
  const pricesStore = useSelector((state) => state.Billing.subscriptionv2.prices);

  useEffect(() => {
    dispatch(walletActions.getWalletInfoRequest());
    dispatch(subscriptionV2Actions.getBillingPricesV2Request())
  }, [dispatch]);

  useEffect(() => {
    if (window.location.host !== "app.salessimplify.com") {
      Paddle.Environment.set("sandbox");
      Paddle.Setup({ seller: 12540 });
    }
    else {
      Paddle.Setup({ seller: 170787 });
    }
  }, [Paddle]);

  useEffect(() => {
    if (!_.isEmpty(walletInfoStore.data)) {
      const data = walletInfoStore.data;
      try {
        setBalance(parseFloat(data.balance));
      } catch (err) {
        setBalance(data.balance);
      }
      if (data.walletAutoNotify) {
        const paylaod = {
          lowBalance: data.walletAutoNotify.lowBalance ? data.walletAutoNotify.lowBalance : planCurrency === "inr" ? 200 : 2,
          emails: data.walletAutoNotify.emails ? data.walletAutoNotify.emails : [],
          isNotify: data.walletAutoNotify.isNotify ? data.walletAutoNotify.isNotify : false,
        };
        setLowCreditNotification(paylaod.emails.join(", "));
        setThreshold(paylaod.lowBalance);
      }

      setIsCredit(data.isCredit);
    }
  }, [walletInfoStore.data, planCurrency]);

  useEffect(() => {
    if (!_.isEmpty(accountBillingStore.data)) {
      if (accountBillingStore.data.walletCurrency) {
        setCurrency(accountBillingStore.data.walletCurrency.toLowerCase() === "inr" ? "₹" : "$");
        setPlanCurrency(accountBillingStore.data.walletCurrency.toLowerCase());
        setDisabledCurreny(true);
      } else {
        setCurrency("$");
        setPlanCurrency("usd");
        setDisabledCurreny(false);
      }
    } else {
      setCurrency("$");
      setPlanCurrency("usd");
      setDisabledCurreny(false);
    }
  }, [accountBillingStore.data]);

  useEffect(() => {
    if (planCurrency === "inr") {
      setVendor("razorpay")
    }
    else {
      setVendor("paddle")
    }

  }, [planCurrency])

  useEffect(() => {
    if (!_.isEmpty(pricesStore.data)) {
      const { wallet } = pricesStore.data;
      const _data = [];
      for (const each in wallet.USD) {
        _data.push({
          amount: each,
          priceId: wallet.USD[each],
        })
      }
      setPaddlePayOptions(_data);
    }

  }, [pricesStore.data])

  const showRazorpayCheckout = (data) => {
    const key = getVendorKey("razorpay");

    const options = {
      "key": key, // Enter the Key ID generated from the Dashboard
      "amount": data.amount.toString(), // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      "currency": data.currency,
      "name": "Salessimplify",
      "description": "Wallet Recharge",
      "image": "https://res.cloudinary.com/salessimplifyimg/image/upload/v1664441814/Sales_Simplify_Logo_324_sq_fwa5bt.png",
      "order_id": data.id,
      "handler": function (response) {
        history.push('/settings/billing/wallet')
      },
      "notes": {
        "address": ""
      }
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }
  const showPaddleCheckout = (priceId) => {
    const data = {
      settings: {
        displayMode: "overlay",
        theme: "light",
        locale: "en",
        allowLogout: false,
        successUrl: window.location.href
      },
      items: [{ priceId: priceId, quantity: 1 }],
      customer: {
        id: accountBillingStore?.data?.customerId,
      },
      customData: {
        accountId: accountBillingStore?.data?.accountId,
        userId: accountBillingStore?.data?.userId,
      }
    }
    Paddle.Checkout.open(data);
    setLoading(false);
  }

  const handleRechargeNowClick = () => {
    if (currency === "$" && addBalance < 10) {
      return dispatchSnackbarError("Minimum amount to be added in your wallet is 10$.");
    } else if (currency === "₹" && addBalance < 1000) {
      return dispatchSnackbarError("Minimum amount to be added in your wallet is ₹1,000.");
    } else if (!vendor) {
      return dispatchSnackbarError("Please select payment method.");
    }
    setLoading(true);
    const payload = {
      amount: addBalance * 100,
      currency: currency === "$" ? "usd" : "inr",
      vendor: vendor,
    };
    if (vendor === "razorpay") {
      payload.amount = addBalance * 118
    }
    if (vendor === "paddle") {
      const find = paddlePayOptions.find(each => each.amount === addBalance);
      if (find) {
        showPaddleCheckout(find.priceId);
      } else {
        dispatchSnackbarError("Something went wrong, please try again later.")
      }
    }
    else {
      dispatch(
        walletActions.createWalletPaymentSessionRequest(payload, (data) => {
          if (data.status) {
            if (vendor === "stripe") {
              setClientSecrent(data.clientSecret);
              setShowAutoRechargeModal(true);
            }
            else if (vendor === "razorpay") {
              showRazorpayCheckout(data)
              setClientSecrent("");
              setShowAutoRechargeModal(false);
            }
          } else {
            dispatchSnackbarError(data.message);
            setClientSecrent("");
            setShowAutoRechargeModal(false);
          }
          setLoading(false);
        }),
      );
    }

  };


  const handleUpdateNotificationClick = () => {
    if (_.isEmpty(lowCreditNotification)) {
      return dispatchSnackbarError("Please enter email to send low credit notifications");
    }
    const emails = _.map(lowCreditNotification.split(","), _.trim);
    for (const email of emails) {
      if (!validator.isEmail(email)) {
        return dispatchSnackbarError("Please enter valid email to send low credit notifications");
      }
    }
    if (currency === "$" && threshold < 2) {
      return dispatchSnackbarError("Low credit threshold cannot be less than 2.");
    } else if (currency === "₹" && threshold < 2) {
      return dispatchSnackbarError("Low credit threshold cannot be less than 200.");
    }

    dispatch(
      walletActions.updateWalletNotifyRequest({
        emails: emails,
        lowBalance: threshold,
      }),
    );
  };



  return (
    <ContentWrapper subHeader={<BillingSubHeader tabName="Wallet" />}>
      <div>
        <div className="card w-100">
          <div className="card-body">
            <div className={`notice d-flex align-items-center mb-6 mt-4 `}>
              <div className="d-flex flex-stack flex-grow-1 fw-bold">
                <div className="d-flex gap-6 align-items-center">
                  <h4 className="text-gray-900 fw-bolder m-0 ">
                    Account Balance:{" "}
                    <span className="text-3699ff">
                      {currency}
                      {balance}
                    </span>
                  </h4>
                  {/* {isCredit ? !showAddBalanceInput ? <div className="badge badge-light-primary cursor-pointer px-3 py-2 d-flex align-items-center gap-2 rounded rounded-pill" onClick={() => setShowAddBalanceInput(true)}>
                                    <i className="bi bi-plus-circle text-primary " /> Balance
                                </div> : <div className=" badge badge-light-danger cursor-pointer px-3 py-2 d-flex align-items-center gap-2 rounded rounded-pill" onClick={() => setShowAddBalanceInput(false)}>
                                    <i className="bi bi-x-circle text-danger " /> Close
                                </div> : null} */}
                </div>
              </div>
            </div>
            {isCredit && (
              <Card className="p-8 mb-8">
                <Form.Group id="settings-billing-containers-wallet-billing-add-balance-and-recharge" className="mt-10 mt-sm-0">
                  <Form.Label aria-label="enter-amount">Enter amount to be added in your wallet</Form.Label>
                  <div className="d-flex flex-wrap gap-3 gap-sm-10 align-items-center">
                    <InputGroup className="w-300px mw-100">
                      <InputGroup.Text id="basic-addon1">{currency}</InputGroup.Text>
                      <Form.Control disabled={vendor === "paddle"} type="number" aria-describedby="basic-addon1" value={addBalance} onChange={(e) => setAddBalance(e.target.value)} />
                    </InputGroup>

                    <Button onClick={() => handleRechargeNowClick()} className="px-4 py-2 cursor-pointer rounded rounded-1 border" size="sm">
                      {loading && <Spinner animation="border" variant="light" className="h-16px w-16px mr-2"></Spinner>}
                      Recharge Now
                    </Button>
                  </div>
                </Form.Group>
                <Form.Group id="settings-billing-containers-wallet-billing-currency" className="d-flex flex-wrap gap-3 mb-0">
                  {vendor !== "paddle" && options[currency].map((each, ind) => {
                    return (
                      <Button key={ind} size="sm" variant="outline-primary border border-primary" onClick={() => setAddBalance(each)}>
                        {currency}
                        {each}
                      </Button>
                    );
                  })}
                  {
                    vendor === "paddle" && paddlePayOptions.map((each, ind) => {
                      return (
                        <Button key={ind} size="sm" variant="outline-primary border border-primary" onClick={() => setAddBalance(each.amount)}>
                          {currency}
                          {each.amount}
                        </Button>
                      );
                    })
                  }
                </Form.Group>
                <Form.Group className="d-none flex-wrap gap-6 mt-6">
                  <div className={`h-60px  border rounded-2 d-flex flex-center px-4 cursor-pointer ${vendor === "stripe" ? "border-primary bg-light-primary" : ""}`} onClick={() => setVendor("stripe")}>
                    {StripeSVG}
                  </div>
                  <div className={`h-60px border rounded-2 d-flex flex-center px-4  cursor-pointer ${vendor === "razorpay" ? "border-primary bg-light-primary" : ""}`} onClick={() => setVendor("razorpay")}>
                    {RazorpaySVG}
                  </div>
                  <div className={`h-60px border rounded-2 d-flex flex-center px-4  cursor-pointer ${vendor === "paddle" ? "border-primary bg-light-primary" : ""}`} onClick={() => setVendor("paddle")}>
                    {PaddleSVG}
                  </div>
                </Form.Group>
                <Form.Group className="d-none">
                  <Button onClick={() => handleRechargeNowClick()} className="px-4 py-2 cursor-pointer rounded rounded-1 border" size="sm">
                    {loading && <Spinner animation="border" variant="light" className="h-16px w-16px"></Spinner>}
                    Recharge Now
                  </Button>
                </Form.Group>
                <div className="position-absolute right-0 mr-5 top-0 mt-3">
                  <div className="step2-part2-interval-wrapper mt-2">
                    <button
                      disabled={disabledCurreny}
                      onClick={() => {
                        setPlanCurrency("inr");
                        setCurrency("₹");
                      }}
                      className={`step2-part2-interval-buttons${planCurrency === "inr" ? "-active" : ""}`}
                    >
                      INR
                    </button>
                    <button
                      disabled={disabledCurreny}
                      onClick={() => {
                        setPlanCurrency("usd");
                        setCurrency("$");
                      }}
                      className={`step2-part2-interval-buttons${planCurrency === "usd" ? "-active" : ""}`}
                    >
                      USD
                    </button>
                  </div>
                </div>
              </Card>
            )}
            <Card className="p-8 mb-8">
              <Row className="d-flex flex-column-reverse flex-sm-row">
                <Col sm={6}>
                  <div className="mb-10 pr-4">
                    <div className="d-flex text-muted fw-bolder fs-5 mb-3">
                      <span className="flex-grow-1 text-gray-800">Low Credit Notification</span>
                    </div>
                    <div className="mb-2">
                      <Form.Control maxLength={InputLimit.TEXTAREA} value={lowCreditNotification} placeholder={"Enter email address..."} onChange={(e) => setLowCreditNotification(e.target.value)} />
                    </div>
                    <div className="fs-6 text-gray-600 fw-bold ">Receive a notification when your account balance fails below threshold.</div>
                  </div>
                  <div>
                    <GreenGradientButton onClick={handleUpdateNotificationClick} size="sm">
                      Update Notification
                    </GreenGradientButton>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="pl-sm-4 pl-0 mb-4 mb-sm-0">
                    <div className="d-flex text-muted fw-bolder fs-5 mb-3">
                      <span className="flex-grow-1 text-gray-800">Low Credit Threshold</span>
                    </div>
                    <div className="mb-2">
                      <InputGroup>
                        <InputGroup.Text id="basic-addon2">{currency}</InputGroup.Text>
                        <Form.Control type="number" aria-describedby="basic-addon2" value={threshold} onChange={(e) => setThreshold(e.target.value)} />
                      </InputGroup>
                    </div>
                    <div className="fs-6 text-gray-600 fw-bold ">When should we start sending the notifications?</div>
                  </div>
                </Col>
              </Row>
            </Card>
          </div>
        </div>
        {/* <AutoRechargeModel
                show={showAutoRechargeModal}
                setShow={setShowAutoRechargeModal}
            /> */}
        {showAutoRechargeModal && <AddStripeBalanceModel show={showAutoRechargeModal} setShow={setShowAutoRechargeModal} clientSecret={clientSecret} currency={currency} amount={addBalance} />}
      </div>
    </ContentWrapper>
  );
}
